import React from 'react';
import { createLazyPage } from '../createLazyPage';
import { AppRouteDefinition } from '../routeDefinition';

const ServerErrorPage = createLazyPage(
  () => import('@app/pages/ServerErrorPage')
);

const Error404Page = createLazyPage(() => import('@app/pages/Error404Page'));

export const errorRoutes: AppRouteDefinition[] = [
  {
    key: 'server-error',
    path: 'server-error',
    element: <ServerErrorPage />,
  },
  {
    key: 'not-found',
    path: '*',
    element: <Error404Page />,
  },
];
